<template>
  <v-container fluid>
    <v-row>
      <v-col cols="3">
        <dataModelLeftList v-if="true" :detailsData="dataModelDetails" :detailsBackData="backupDataModelDetails"
          @selecthandle="selecthandle" @refershData="refershData" class="model-list" />
      </v-col>
      <v-col cols="9">
        <div class="rightTitle">
          <span>{{ toTitleCase($route.query.name) }}</span>
        </div>
        <v-card class="mt-5" style="height: 70vh !important; overflow-y: auto">
          <v-tabs v-model="tab" active-class="active">
            <v-tab v-for="item in items" :key="item" :text="item" :value="item"></v-tab>
          </v-tabs>
          <v-tabs-window v-model="tab" style="overflow-y: auto; height: 80%">
            <v-tabs-window-item value="Details" class="pa-4">
              <Details :formData="formData" :showReadOnly="showReadOnly"/>
            </v-tabs-window-item>
          </v-tabs-window>
          <v-card-action>
            <v-row justify="end" class="dialogBottom ml-1 mb-1" v-if="!showReadOnly">
              <!-- <v-btn v-if="tab != 'Details'" class="mr-2 cancel" @click="handleBack">Back</v-btn> -->
              <v-btn class="mr-2 cancel" @click="handleCancel">Cancel</v-btn>
              <!-- <v-btn v-if="tab != 'Styling'" class="save" @click="handleNext" :loading="saveClicked"
                type="submit">Next</v-btn> -->
              <v-btn @click="handelSave" class="save" :loading="saveClicked"
                type="submit" :disabled="showReadOnly">Save</v-btn>
            </v-row>
          </v-card-action>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :timeout="4000" location="top" color="primary">
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>
<script>
import dataModelLeftList from "./dataModelLeftList.vue";
import dataModelDetailsService from "../../api/service/DataModelDetails/DataModelsDetailsService";
import Details from "./Details.vue";

export default {
  components: {
    dataModelLeftList,
    Details,
    // Filter,
    // Formatters,
    // Styling
  },
  data() {
    return {
      tab: "Details",
      snackbar: false,
      snackbarText: null,
      formData: {},
      showReadOnly: false,
      dataModelDetails: [],
      backupDataModelDetails: [],
      modelId: null,
      saveClicked: false,
      items: ["Details"]
    }
  },
  mounted() {
    this.showReadOnly = this.$route.query.readOnly == "true" ? true : false;
    if (this.$route.query.model_id) {
      this.getDataModelList();
    }
  },
  methods: {
    async getDataModelList() {
      try {
        this.modelId = this.$route.query.model_id;
        this.dataModelDetails = await dataModelDetailsService.findAll({
          model_id: this.modelId,
          deleted: 0,
        });
        this.dataModelDetails.forEach((e) => {
          e.isActive = false;
        });
        this.backupDataModelDetails = JSON.parse(
          JSON.stringify(this.dataModelDetails)
        );
        for (let key in this.formData) {
          if (key !== "model_id") {
            this.formData[key] = null;
          }
        }
      } catch (e) {
        console.log(e, "error");
      }
    },
    async handleNext() {
      if (this.tab == "Details") {
        if (this.formData.id) {
          this.formData.styles = JSON.stringify(this.formData.styles);
          this.formData.computed_expression = JSON.stringify(this.formData.computed_expression);
          this.formData.options = JSON.stringify(this.formData.options);
          let data = JSON.parse(JSON.stringify(this.formData));
          delete data.computedfield;
          await dataModelDetailsService.update(data);
          this.formData.styles = JSON.parse(this.formData.styles);
          this.formData.computed_expression = JSON.parse(this.formData.computed_expression);
          this.formData.options = JSON.parse(this.formData.options);
          this.snackbar = true;
          this.snackbarText = "DataModel Details Updated Successfully";
        }
        this.tab = "Filters";
      } else if (this.tab == "Filters") {
        if (
          this.formData &&
          this.formData.source_type &&
          (this.formData.source_type == "enums" ||
            this.formData.source_type == "enum")
        ) {
          this.formData.text = "display_value";
          this.formData.value = "data_value";
        }
        if (this.formData.id) {
          this.formData.options = JSON.stringify(this.formData.options);
          this.formData.styles = JSON.stringify(this.formData.styles);
          this.formData.computed_expression = JSON.stringify(this.formData.computed_expression);
          let data = JSON.parse(JSON.stringify(this.formData));
          delete data.computedfield;
          // let output = await dataModelDetailsService.updateOne(data);
          this.formData.styles = JSON.parse(this.formData.styles);
          this.formData.computed_expression = JSON.parse(this.formData.computed_expression);
          this.formData.options = JSON.parse(this.formData.options);
          this.snackbar = true;
          this.snackbarText = "DataModel Details Updated Successfully";
          // this.$emit("reload", output.model_id);
        }
        this.tab = "Formatters";
      } else {
        if (this.formData.id) {
          this.formData.formatters =
            this.formData && this.formData.show_column
              ? JSON.stringify(this.formData.formatters)
              : this.formData.formatters;
          this.formData.styles = JSON.stringify(this.formData.styles);
          this.formData.computed_expression = JSON.stringify(this.formData.computed_expression);
          this.formData.options = JSON.stringify(this.formData.options);
          let data = JSON.parse(JSON.stringify(this.formData));
          delete data?.computedfield;
          // let output = await dataModelDetailsService.updateOne(data);
          this.formData.styles = JSON.parse(this.formData.styles);
          this.formData.computed_expression = JSON.parse(this.formData.computed_expression);
          this.formData.options = JSON.parse(this.formData.options);
          this.snackbar = true;
          this.snackbarText = "DataModel Details Updated Successfully";
          // this.$emit("reload", output.model_id);
        }
        this.tab = "Styling";
      }
    },
    handleBack() {
      if (this.tab == "Filters") {
        this.tab = "Details";
      } else if (this.tab == "Formatters") {
        this.tab = "Filters";
      } else {
        this.tab = "Formatters";
      }
    },
    refershData() {
      this.getDataModelList();
    },
    async handelSave() {
      if (this.formData.id) {
        // alert(1)
        this.formData.styles = JSON.stringify(this.formData.styles);
        this.formData.computed_expression = JSON.stringify(this.formData.computed_expression);
        this.formData.options = JSON.stringify(this.formData.options);
        let data = JSON.parse(JSON.stringify(this.formData));
        delete data.computedfield;
        delete data.isActive;
        console.log(data,"data###")
        await dataModelDetailsService.update(data);
        this.formData.styles = JSON.parse(this.formData.styles);
        this.formData.computed_expression = JSON.parse(this.formData.computed_expression);
        this.formData.options = JSON.parse(this.formData.options);
        this.snackbar = true;
        this.snackbarText = "DataModel Details Updated Successfully";
        this.tab = "Details";
        for (let key in this.formData) {
          if (key !== "model_id") {
            this.formData[key] = null;
          }
        }
      } else {
        // let output = await dataModelDetailsService.create(this.formData);
        // for (let key in this.formData) {
        //   if (key !== "model_id") {
        //     this.formData[key] = null;
        //   }
        // }
      }
      this.getDataModelList();
    },
    toTitleCase(input) {
      return input
        .toLowerCase()
        .split(" ")
        .map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
        )
        .join(" ");
    },
    selecthandle(value) {
      console.log(value, "value of selected")
      value.filter_required = value.filter_required == 1 ? true : false;
      value.form_required = value.form_required == 1 ? true : false;
      value.column_required = value.column_required == 1 ? true : false;
      value.multi_select = value.multi_select == 1 ? true : false;
      value.show_column = value.show_column == 1 ? true : false;
      if (typeof value.options === "string") {
        value.options = JSON.parse(value.options);
      } else {
        // value.options = value.options;
      }
      if (typeof value.styles === "string") {
        value.styles = JSON.parse(value.styles);
      } else {
        // value.styles = value.styles;
      }
      if (typeof value.formatters === "string" && value.show_column) {
        value.formatters = JSON.parse(value.formatters);
      } else {
        // value.formatters = value.formatters;
      }
      if (typeof value.computed_expression === "string") {
        value.computed_expression = JSON.parse(value.computed_expression);
        value.computedfield = true
      } else {
        // value.computed_expression = value.computed_expression;
        value.computedfield = value && value.computed_expression && value.computed_expression.exprssion_json ? true : false
      }
      this.formData = value;
      console.log(this.formData,'this.formData88888')
    },
    handleCancel() {
      this.$router.go(-1);
    }
  }
}
</script>
<style scoped>
>>>.lookup .v-input--density-default {
  --v-input-control-height: 22px !important;
  --v-input-padding-top: 0px !important;
}

>>>.lookup .v-field__field .v-field__input {
  padding-bottom: 0px !important;
}

>>>.v-tab.v-tab.v-btn {
  margin-inline-start: 15px !important;
  text-transform: capitalize;
}

.rightTitle {
  padding: 8px !important;
  border-radius: 2px;
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
}


/* >>>.v-window__container{
  height: 600px;
  overflow-y: auto;
} */

/* >>> .v-autocomplete .v-field.v-field {
  background-color: #fff;
} */
</style>
